import { render, staticRenderFns } from "./extensionUpload.vue?vue&type=template&id=4703bb1e&"
import script from "./extensionUpload.vue?vue&type=script&lang=js&"
export * from "./extensionUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports